// QuantityIncrementer.tsx
import React from 'react';
import s from '../QuantityCards/QuantityCards.module.scss';

// These selectors and actions are just illustrative imports.
// Update them according to your actual file paths.
import { usewpdataSelectors } from 'lib/wpdataState/selectors';
import { useCartSelectors } from 'lib/cartState/selectors';
import { useCartActions } from 'lib/cartState/actions';

const QuantityIncrementer: React.FC = () => {
  const { hero } = usewpdataSelectors();
  const { cartProducts } = useCartSelectors();
  const { adjustItemQuantityAction } = useCartActions();

  // For example, find an item whose type is "offer"
  const activeOffer = cartProducts.find((item) => item.type === 'offer');
  const currentAmount = activeOffer ? Number(activeOffer.amount) : 0;

  const handleDecrement = () => {
    if (!activeOffer || currentAmount <= 1) return;

    const newQty = currentAmount - 1;
    // Pass the UUID as a string, no conversion to Number
    adjustItemQuantityAction({
      id: activeOffer.id,
      quantity: newQty,
    });
  };

  const handleIncrement = () => {
    if (!activeOffer) return;

    const newQty = currentAmount + 1;
    // Pass the UUID as a string
    adjustItemQuantityAction({
      id: activeOffer.id,
      quantity: newQty,
    });
  };

  return (
    <div className={s.ctaWrapper__incrementer}>
      <button
        className={s.quantityAdjustButton}
        style={{
          cursor: 'pointer',
          color: currentAmount === 1 ? '#E5E5E5' : hero.styles.textColorPrimary,
        }}
        onClick={handleDecrement}
      >
        -
      </button>
      <div style={{ color: hero.styles.textColorPrimary }}>{currentAmount}</div>
      <button
        className={s.quantityAdjustButton}
        style={{ cursor: 'pointer', color: hero.styles.textColorPrimary }}
        onClick={handleIncrement}
      >
        +
      </button>
    </div>
  );
};

export default QuantityIncrementer;
